export default (path) => (new URL(`https://api.brainbbox.com${path}`).href); 
// export default (path) => (new URL(`http://localhost:8080${path}`).href); 